var app = angular.module('app', ['ui.utils', 'ui.scrollfix']);

app.config(function($interpolateProvider) {
  $interpolateProvider.startSymbol('//');
  $interpolateProvider.endSymbol('//');
});

app.directive('usVideo', function($window) {
	return {
		link: function($scope, $element, attrs) {
			// TODO: element needs to initialize video.js
			// TODO: optionally vertically center video element with background-size: cover; like functionality via argument
			// TODO: start playing video upon scope change? 5 second autoplay video needs to convert to a full clip upon click in one way or another
		}
	}
})

app.directive('usScrollDirection', function($window) {
	return {
		restrict: 'A',
		link: function($scope, $element, attrs) {
			// store last 60 positions.. if average over 50%, note up or down.
			var sampleCount = Number(attrs.usScrollDirection) || 30;
			var lastValues = Array.apply(null, new Array(sampleCount)).map(Number.prototype.valueOf,0);;
			var lastValue = 0;
			var $$window = $($window);

			function onScrollFunc() {
				var scrollTop = $$window.scrollTop();
				var value = 0;

				// only count actual movement.. scroll event can fire multiple times per pixel
				if (scrollTop == lastValue) {
					return;
				}

				// store direction
				if (scrollTop > lastValue && scrollTop > 0 && scrollTop) {
					value = 1;
				}
				lastValues.unshift(value);
				lastValues.pop();
				lastValue = scrollTop;

				var sum = lastValues.reduce(function(a, b) { return a + b });
				var avg = sum / lastValues.length;

				if (avg < .5) {
					$element.addClass('is-going-up');
					$element.removeClass('is-going-down');
				} else {
					$element.addClass('is-going-down');
					$element.removeClass('is-going-up');
				}
			};
			angular.element($window).bind('scroll', onScrollFunc);
		}
	}
})

// Menu
///////
app.controller('NavController', function($scope) {
	$scope.canHideNavbar = true;
})

app.controller('MenuController', function($scope) {
	$scope.canShowMenu = true;
	$scope.showMenu = function($event) {
		$event.stopPropagation();
		$scope.$parent.canHideNavbar = false;
		if ($scope.canShowMenu == true) {
			$scope.slideoutCls = 'is-open';
		}
	}
	$scope.closeMenu = function() {
		$scope.slideoutCls = 'is-closed';
		$scope.canShowMenu = false;


		// TODO: refactor 
		$scope.$parent.canHideNavbar = true;
		setTimeout(function() {
			$scope.canShowMenu = true;
		}, 300);
	}

	// this could be accomlished by adding a ng-click="closeMenu()"
	// but somehow that feels uglier.. but if we add js-specific tags like js-menu-item it's still quite repetitive.
	$(".nav-menu-item").on('click', function(ev) {
		$scope.closeMenu();
		$scope.$digest();
	})

	// close menu if clicked outside of menu
	$(document).on('click', function(ev) {
		if ($(ev.target).closest('.nav-menu-slideout').length == 0) {
			$scope.closeMenu();
			$scope.$digest();
		}
	})
});

// CART
///////
app.service('CartServices', function($http, $q) {
	var self = this;
	// get and prepare items from Shopify.
	this.getItemsFromShopify = function() {
		var deferred = $q.defer();
		$http.get('/cart.js', {
			method: 'get'
		}).success(function(data, status, headers, config) {
			// prepare shopify cart items into format necessary by angular
			// pull say cart notes to get sizing info
			var cart = data;
			items = [];
			for (var i = cart.items.length - 1; i >= 0; i--) {
				var item = cart.items[i];
				items.push(item);
			};
			deferred.resolve({
				item_count: cart.item_count == 0 ? '' : cart.item_count,
				items: items
			});
		}).error(function(response) {
			deferred.reject(response);
		});
		return deferred.promise;
	}
});

app.controller('CartController', ['$scope', 'CartServices', function($scope, CartServices) {
	$scope.cartCount = '';
	CartServices.getItemsFromShopify().then(function(data) {
		$scope.cartCount = data.item_count;
		$scope.items = data.items;
		console.log("Got data from shopify... $scope.items is", data.items, data);
	});

	$scope.canShowMenu = true;
	$scope.showMenu = function($event) {
		$event.stopPropagation();  // ensure document click handler doesn't trigger.
		$scope.$parent.canHideNavbar = false;
		if ($scope.canShowMenu == true) {
			$scope.slideoutCls = 'is-open';
		}
	}
	$scope.closeMenu = function() {
		$scope.slideoutCls = 'is-closed';
		$scope.canShowMenu = false;
		$scope.$parent.canHideNavbar = true;
		setTimeout(function() {
			$scope.canShowMenu = true;
		}, 300);
	}
	$scope.showSearch = function() {
		$scope.searchCls = 'is-open';
	}
	$scope.hideSearch = function() {
		$scope.searchCls = 'is-closed';
	}
	$scope.addToCart = function() {

	}

	// close menu if clicked outside of menu and it's not the one that showed the menu.
	$(document).on('click', function(ev) {
		if ($(ev.target).closest('.nav-cart-slideout').length == 0) {
			$scope.closeMenu();
			$scope.$digest();
		}
	})
}]);

// Product Nav Controller
/////////////////////////

app.controller('ProductNavController', ['$scope', '$element', function($scope, $element) {
	var pnc = this;

	pnc.close = function() {
		// $scope.open = false;

		// TODO: [low] @airpair Refactor to replace jQuery DOM updates with Angular scopes. Requires index/product controllers implementing ui-scrollfix to know to modify a child scope... or better angular logic in general.

		// if the product nav is controlled via angular, it also needs to be in the index controllers..
		// i.e. open on scrolling down.
		var $uiScrollfixElement = $($element).closest('.ui-scrollfix');
		$uiScrollfixElement.addClass('is-going-up').removeClass('is-going-down');
	}
}])

// Index
////////

app.controller('IndexController', indexController);
indexController.$inject = ['$scope'];

function indexController($scope) {
	console.log("Scope index");
	var index = this;

	$scope.hideAllChildren = function() {
		console.log("Hiding all children");

		for (var i = $scope.slideControllers.length - 1; i >= 0; i--) {
			$scope.slideControllers[i].hide();
		};
	}


	$scope.slideControllers = [];
}

app.controller('SlideController', slideController);
slideController.$inject = ['$scope'];

function slideController($scope) {
	var sc = this;
	console.log("Slide controller init");
	// $scope.$parent.slideControllers.push(sc);

	sc.visible = false;

	sc.showToggle = function() {
		if (sc.visible == true) {
			sc.hide();
		} else {
			sc.show();
		}
	}
	sc.show = function() {
		// show contents.
		// TODO: Slide down fade instead of insta show. Can do this by using jQ here?
		// $scope.$parent.hideAllChildren();
		sc.visible = true;
	}
	sc.hide = function() {
		sc.visible = false;
	}


}


app.controller('ProductNavController', ['$scope', '$element', function($scope, $element) {
	var pnc = this;

	pnc.close = function() {
		// TODO: [low] @airpair Refactor to replace jQuery DOM updates with Angular scopes. Requires index/product controllers implementing ui-scrollfix to know to modify a child scope... or better angular logic in general.
		// correct way to do this is to modify index/product scroll direction to update the child controllers.
		// does that require the directive to set some scope variables, then have the controller watch that scope?
		var $uiScrollfixElement = $($element).closest('.ui-scrollfix');
		$uiScrollfixElement.addClass('is-going-up').removeClass('is-going-down');
	}
}])

app.controller("BenController", function($scope) {
	$scope.someVar = 'hi ben';

})



// FROM ANGULAR AIRPAIR
///////////////////////

// app.controller('MyController', function($scope) {

// })


// (function () {
//   'use strict';

//   angular
//   .module('app')
//   .factory('dataService', dataService);

//   dataService.$inject = ['$http', '$resource', 'Restangular'];

//   function dataService($http, $resource, Restangular) {
// 	  var values = [];
// 	  var value = '';

// 	  var service = {
// 		  value: value,
// 		  values: values,
// 		  getValuesHttp: getValuesHttp,
// 		  getSingleValueHttp: getSingleValueHttp,
// 		  getValuesResource: getValuesResource,
// 		  getValueByIdResource: getSingleValueResource,
// 		  getValuesRestangular: getValuesRestangular,
// 		  getValueByIdRestangular: getSingleValueRestangular
// 	  };

// 	  return service;


// 	  function getValuesHttp() {
// 	  return $http.get('/api/values')
// 	  .then(success)
// 	  .catch(fail);

// 	  function success(result) {
// 	  console.log(['Http: Got values', result]);
// 	  return result.data;
// 	  }

// 	  }
// 	  function getValuesResource() {
// 	  var api = $resource('/api/values');
// 	  return api.query().$promise
// 	  .then(success)
// 	  .catch(fail);

// 	  function success(result) {
// 	  console.log(['Resource: Got values', result]);
// 	  return result;
// 	  }
// 	  }

// 	  function getValuesRestangular() {
// 	  var baseValuesApi = Restangular.all('api/values');
// 	  return baseValuesApi.getList()
// 	  .then(success)
// 	  .catch(fail);

// 	  function success(result) {
// 	  console.log(['Restangular: Got values', result]);
// 	  return result;
// 	  }
// 	  }

// 	  function getSingleValueHttp(valueId) {
// 	  var config = {
// 	  params: {
// 	  id: valueId
// 	  },
// 	  responseType: 'json'
// 	  };
// 	  return $http.get('/api')
// })()

